import React from "react";
import { Routes, Route } from 'react-router-dom';
import "./App.css";
import Navbar from "./Navbar";
import AboutMe from "./AboutMe";
import Navbar3 from "./Navbar3";
import Navbar4 from "./Navbar4";
import ContactUs from "./ContactUs";
import ContactUs1 from "./ContactUs1";

import Comingsoon from "./Comingsoon";
import ProjectShowcasePage from "./ProjectShowcasePage";

// import "./Navbar.css"
import Navbarmain from "./Navbarmain";
import CertificationShowcase from "./CertificationShowcase";
import CertificateCard from "./CertificateCard";

function App() {
  return (
    <div className="flex flex-col h-screen">
      <Navbarmain />
      <Navbar />

    
        <Navbar4 />
        <Navbar3 />
        <CertificationShowcase />
        {/* <ProjectShowcasePage/> */}
        <AboutMe />
        <ContactUs />
      <Routes>
     

        <Route path="/Navbar" element={<Navbar />} /> 
        <Route path="/Navbar3" element={<Navbar3 />} />
        <Route path="/Navbar3" element={<Navbar3 />} />
        <Route path="/Navbar4" element={<Navbar4 />} />
        <Route path="/CertificationShowcase" element={<CertificationShowcase/>} />
        <Route path="/AboutMe " element={<AboutMe />} />
        <Route path="/ContactUs" element={<ContactUs />} /> 
        <Route path="/ContactUs1" element={<ContactUs1 />} /> 
      </Routes>
    </div>
  );
}

export default App;
